import { Heading } from '../../../components'
import { InstOwnFiler } from '../constants'
import { getInvestorNameFromFiler } from '../utils'

interface Props {
  filer?: InstOwnFiler | null
}

export function ManagerHeading({ filer }: Props) {
  return (
    <Heading level={2} className="text-muted">
      {getInvestorNameFromFiler(filer)}
    </Heading>
  )
}
